import React from "react";
import "./detailTwo.scss";
import jtR from "../../assets/jt-r.png"
import productQuestion1 from "../../assets/productions/product-question1.png"
import productQuestion2 from "../../assets/productions/product-question2.png"
import productQuestion3 from "../../assets/productions/product-question3.png"
import brainData from "../../assets/productions/brainData.png"
import system from "../../assets/productions/row-1-img2.png"
import reportL from "../../assets/productions/report-l.png"
import reportR from "../../assets/productions/report-r.png"
import dataManage from "../../assets/productions/data-manage.png";
import userManage from "../../assets/productions/user-manage.png"

class DetailTwo extends React.Component {
    
    render() {
        return <div className="detail-2">
            <div className="title">
                <div>多中心多模态磁共振脑影像队列研究亟需解决</div>
                <div>数据质量不佳、中心间数据差异较大、数据存储杂乱无章等问题</div>
            </div>
            <div className="questions">
                <div className="ques">
                    <img src={productQuestion1} />
                    <div className="desc">
                        <p>磁共振设备不稳定</p>
                        <p>导致中心间数据无法比较</p>
                    </div>
                </div>
                <span className="line"></span>
                <div className="ques">
                    <img src={productQuestion2} style={{ width: "230px" }}/>
                    <div className="desc">
                        <p>数据质量较差</p>
                        <p>阻碍获得</p>
                        <p>可靠的脑影像特征</p>
                    </div>
                </div>
                <span className="line"></span>
                <div className="ques">
                    <img src={productQuestion3} style={{ width: "230px" }}/>
                    <div className="desc">
                        <p>数据存储杂乱</p>
                        <p>人工整理极易出错</p>
                        <p>影响数据汇交</p>
                    </div>
                </div>
            </div>
            <div className="part-2">
                <div className="title">
                    <div className="line" style={{ left: 0 }}></div>
                    <div className="title-txt">
                        <div>NeuroCollector™系统</div>
                        <div>“一站式”解决方案</div>
                    </div>
                    <div className="line" style={{ right: 0 }}></div>
                </div>
                <div className="content-2">
                    <div className="content-left">
                        <p>脑影像原始数据</p>
                        <img src={brainData} />
                    </div>
                    <img src={jtR} className="content-2-arrow"/>
                    <div className="content-right">
                        <p>NeuroCollector<sup>TM</sup>系统</p>
                        <img src={system} />
                    </div>
                </div>
            </div>
            <div className="part-3">
                <div className="title">
                    <div className="line" style={{ left: 0 }}></div>
                    <div className="title-txt">
                        <p>NeuroCollector<sup>TM</sup>提供完备的脑影像数据质控与管理方案</p>
                        <p>保证脑影像数据质量，为多中心队列研究保驾护航</p>
                    </div>
                    <div className="line" style={{ right: 0 }}></div>
                </div>
                <div className="collector-img-txt">
                    <div className="item">
                        <img src={reportL} />
                        <div>
                            <p>提供客观量化的</p>
                            <p>磁共振设备质量评估报告</p>
                        </div>
                    </div>
                    <div className="item">
                        <img src={reportR} />
                        <div>
                            <p>提供客观量化的多模态脑影像</p>
                            <p>数据质量评估报告</p>
                        </div>
                    </div>
                </div>
                <div className="manage">
                    <div className="manage-img">
                        <div className="user">
                            <img src={userManage} />
                        </div>
                        <div className="data">
                            <img src={dataManage} />
                        </div>
                    </div>
                    <p className="manage-desc">实现三级用户权限管理和科学的数据规整</p>
                </div>
            </div>
        </div>
    }
}
export default DetailTwo;